import React, { useCallback } from "react";
import NiceModal from "@ebay/nice-modal-react";

import { Button } from "components";
import { ProjectOrFolderDownloadModal } from "components/_Modals/ProjectDownloadModal/ProjectOrFolderDownloadModal";
import { useNodes, useProjectId } from "stores/wizardStore";
import { UncontrolledTooltip } from "reactstrap";
import { translate } from "hooks";
import { CreatePDFModal } from "components/_Modals/CreatePDFModal/CreatePDFModal";

export function TopologyTopBarIcons() {
  const projectId = useProjectId();
  const nodes = useNodes();
  const wizardRootFolder = nodes.find(
    (node) => node.kind === "WIZARD_ROOT_FOLDER",
  );

  const { title, id } = wizardRootFolder;

  const openCreatePDFModal = useCallback(() => {
    NiceModal.show(CreatePDFModal);
  }, []);

  const handleDownloadBtn = useCallback(
    () =>
      NiceModal.show(ProjectOrFolderDownloadModal, {
        modalSubtitle: title,
        wizardId: id,
        projectId,
      }),
    [title, id, projectId],
  );

  return (
    <>
      <Button
        data-testid="TopologyTopBar_download-btn"
        color=""
        icon="arrow-down-bracket-regular"
        iconClassName="icon-16"
        id="topologyDownload"
        classNames="h-100 px-2 py-0 border-0"
        onClick={handleDownloadBtn}
      />
      <UncontrolledTooltip target={`topologyDownload`} placement="top">
        {translate("DOWNLOAD")}
      </UncontrolledTooltip>
      <Button
        data-testid="TopologyTopBar_createPDF-modal-btn"
        color=""
        icon="PDF-regular"
        id="topology-PDF-generate"
        iconClassName="icon-16"
        classNames="h-100 px-2 py-0 border-0 border-start border-gray-400"
        onClick={openCreatePDFModal}
      />
      <UncontrolledTooltip target={`topology-PDF-generate`} placement="top">
        {translate("WIZARDS_TOPOLOGY_AS_PDF_TITLE")}
      </UncontrolledTooltip>
      {/* TODO: forthcoming feature (hidden acc US-19953) */}
      {/* <Dropdown
        btnChildren={
          <Icon prefix="trox" iconName="ellipsis-vertical-regular" />
        }
        options={[
          {
            id: "wizard_change_name",
            title: translate("WIZARD_CHANGE_NAME"),
            onClick: () => {},
          },
          {
            id: "wizard_reset_name",
            title: translate("WIZARD_RESET_NAME"),
            onClick: () => {},
          },
          {
            id: 2,
            title: translate("WIZARD_SAVE_AS_TEMPLATE"),
            onClick: () => {},
          },
        ]}
      /> */}
    </>
  );
}
